import 'core-js/es/object';
import 'core-js/es/string';
import 'core-js/es/object';
import 'core-js/es/array';
import 'core-js/es/map';
import 'core-js/es/promise';

try {
  new Event('checkEventConstructor');
} catch (ignoredError) {
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    /* eslint no-var: 0 */
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.Event = CustomEvent;
}

export default undefined;
